import { render } from "./product-judgeme-reviews.vue?vue&type=template&id=ff8fd724"
import script from "./product-judgeme-reviews.vue?vue&type=script&lang=js"
export * from "./product-judgeme-reviews.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__